<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { AlternativeEditorAttributeFieldReadModel } from "@Alternatives/Alternatives/Domain/readmodels";
    import { ValidationError } from "@common/types";
    import { formatStringForDateInput } from "@common/Common";

    @Component({
        props: {
            propF: { type: Object, required: true },
            propErrors: { type: Array, required: true },
        },
        watch: {
            value: 'onValueChanged'
        }
    })
    export default class DateInputSingleValue extends Vue
    {
        get f(): AlternativeEditorAttributeFieldReadModel { return this.$props.propF as AlternativeEditorAttributeFieldReadModel; }
        get errors(): ValidationError[] { return this.$props.propErrors as ValidationError[]; }

        get error() { return this.errors?.find(error => error.Context.startsWith(`AlternativeAttribute:${this.f.Id}`))?.Error; }
        get minDate(): string | null { return formatStringForDateInput(this.f.MinDate); }
        get maxDate(): string | null { return formatStringForDateInput(this.f.MaxDate); }

        value: string | null = null;

        //@Watch('value')
        onValueChanged(newValue: string)
        {
            this.f.Value = newValue;
        }

        mounted()
        {
            this.value = formatStringForDateInput(this.f.Value);
        }
    }
</script>

<template>
    <div class="form-group">
        <label>
            <span v-if="f.IsRequired" style="color: red;">*</span> {{f.Name}}
        </label>
        <input type="date" class="form-control" placeholder="Date..." title="Please enter date"
               v-model="value"
               :required="f.IsRequired === true"
               :readonly="f.IsReadonly === true"
               :min="minDate"
               :max="maxDate" />

        <div class="error">{{error}}</div>
        <small class="form-text text-muted" v-if="f.Description">{{f.Description}}</small>
    </div>
</template>